import Field from './fields';

/**
 * Создает экземпляр Form.
 *
 * @constructor
 * @this  {Form}
 * @param {form} r - HTML элемент формы.
 */
class Form {
  constructor(form) {
    this.form = form;
    this.fields = [];

    this.init();
  }

  /** @private */
  init() {
    if (!this.form.classList.contains('_init')) {
      this.initFields();
      this.addEventListeners();
      this.setGlobalMethodsForm();

      this.form.classList.add('_init');
    }
  }

  /** @private */
  initFields() {
    const inputs = this.form.querySelectorAll('input[data-required]');
    const selects = this.form.querySelectorAll('select');
    const textareas = this.form.querySelectorAll('textarea[data-required]');

    inputs.forEach((item) => {
      this.fields.push(new Field(item));
    });

    selects.forEach((item) => {
      this.fields.push(new Field(item));
    });

    textareas.forEach((item) => {
      this.fields.push(new Field(item));
    });
  }

  /** @private */
  addEventListeners() {
    this.form.addEventListener('submit', async (e) => {
      if (!this.validationForm()) {
        e.preventDefault();
      }

      if (this.form.classList.contains('change-password')
        || this.form.classList.contains('create-new-password')) {
        e.preventDefault();

        const formData = new FormData();
        this.fields.forEach((field) => {
          formData.append(field.field.name, field.field.value);
        });

        const rawResponse = await fetch(
          this.form.action,
          {
            method: 'POST',
            body: formData,
          },
        );

        const response = await rawResponse.json();

        let result = this.form.querySelector('.massage-changed');
        if (!result) {
          result = document.createElement('span');
          result.classList.add('massage-changed');
        }

        if (response.status === 'success') {
          result.innerText = this.form.classList.contains('create-new-password') ? 'Пароль создан' : 'Пароль изменен';
          if (!this.form.querySelector('.massage-changed')) {
            this.form.append(result);
          }
          this.form.reset();
        } else if (response.status === 'error') {
          result.innerHTML = response.errors[0].message;
          if (!this.form.querySelector('.massage-changed')) {
            this.form.append(result);
          }
          this.form.reset();
        }
      }
    });
  }

  /** @private */
  setGlobalMethodsForm() {
    const self = this;
    this.form.validationForm = () => self.validationForm();
    this.form.resetValidationForm = () => self.resetValidationForm();
  }

  validationForm() {
    return this.fields.reduce((accumulator, field) => {
      const resultValiudation = field.validation();
      return accumulator ? resultValiudation : false;
    }, true);
  }

  resetValidationForm() {
    this.fields.forEach((field) => {
      field.removeError();
    });
  }

  scrollToTop() {
    this.form.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}

export default Form;
